/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import SlotContent from '../Slot/SlotContent';
import noteIcon from '../../../../assets/images/Fireboard/note-white.png';
import classes from './CheckList.module.css';

const CheckList = ({
  checkList,
  checksForAssignment,
  onSelectCheckForAssignment,
  ascending,
  checkSortFunc,
  onShowCheckDetails,
}) => {

  const showCheck = check => {
    const [order0] = check?.orders || [];
    const { storeCubbySlotId, pickUpStatus } = order0 || {};
    return (pickUpStatus === 0 && !storeCubbySlotId);
  };

  const onSelectCheck = check => {
    onSelectCheckForAssignment && onSelectCheckForAssignment(check);
  };

  const sortChecks = checks => {
    const sortedChecks = [...checks];
    sortedChecks.sort(checkSortFunc);
    if (!ascending) {
      sortedChecks.reverse();
    }
    return sortedChecks;
  };

  return (
    <React.Fragment>
      {sortChecks(checkList).map(check =>
        showCheck(check) && (
          <div className={classes.tile} key={check.id}>
            <div className={classes.slotHeader}>
              <div className={classes.checkMarkWrapper} onClick={() => onSelectCheck(check)}>
                {checksForAssignment && checksForAssignment.has(check.checkHeaderId) && (
                  <span className={classes.checkMark}>&#10003;</span>
                )}
              </div>
              <span className={classes.slotName}>{check?.checkNumber}</span>
              <img
                src={noteIcon}
                alt='note'
                className={classes.noteImg}
                onClick={() => onShowCheckDetails(check)}
              />
            </div>
            <SlotContent
              check={check}
              showCheckNumber={false}
              showDeliveryVendor={false}
              showMarketplaceVendor={false}
              showPickupTime={true}
              WebkitLineClamp={2}
            />
          </div>
        )
      )}
    </React.Fragment>
  );
};

export default CheckList;

CheckList.propTypes = {
  checkList: PropTypes.array.isRequired,
  checksForAssignment: PropTypes.instanceOf(Map),
  onSelectCheckForAssignment: PropTypes.func,
  ascending: PropTypes.bool,
  checkSortFunc: PropTypes.func,
  onShowCheckDetails: PropTypes.func,
};

CheckList.defaultProps = {
  checkList: [],
  checksForAssignment: new Map(),
  onSelectCheckForAssignment: () => { },
  ascending: true,
  checkSortFunc: () => { },
  onShowCheckDetails: () => { },
};
